// Ways from the desktop page to the phone version: a "Play on your phone"
// button that shows a QR code of /phone (#17), and a dismissible banner for
// people who open the desktop page on a phone anyway (#20).

import { createSharePanel } from '../shared/sharePanel.js';
import { phoneUrl } from '../shared/shareUrl.js';
import { loadJSON, saveJSON } from '../shared/storage-kit.js';

const BANNER_DISMISSED_KEY = 'farmatc.phoneBanner.dismissed.v1';
const NARROW_TOUCH = '(pointer: coarse) and (max-width: 820px)';

/** Wire the "Play on your phone" button to a QR share panel for the phone page. */
export function attachPlayOnPhone(button, { location = window.location } = {}) {
  let panel = null;
  button.addEventListener('click', () => {
    if (!panel) {
      panel = createSharePanel({
        url: phoneUrl(location, '/phone'),
        title: 'Play on your phone',
        hint: 'Point your phone camera at the code to open Farm ATC, the quick phone game.',
      });
    }
    panel.open();
  });
}

/**
 * Show the "try the phone version" banner on a narrow touch screen, unless
 * it was dismissed before. Returns whether it's showing.
 */
export function maybeShowPhoneBanner(banner, {
  matchMedia = globalThis.matchMedia?.bind(globalThis),
  storage,
} = {}) {
  const narrowTouch = Boolean(matchMedia?.(NARROW_TOUCH)?.matches);
  if (!narrowTouch || loadJSON(BANNER_DISMISSED_KEY, (v) => v === true, storage)) return false;
  banner.hidden = false;
  banner.querySelector('.dismiss').addEventListener('click', () => {
    banner.hidden = true;
    saveJSON(BANNER_DISMISSED_KEY, true, storage);
  });
  return true;
}
